import React from 'react'
import { useHistory } from '@fs/zion-router'

const BackNavigationContext = React.createContext(false)

export function BackNavigationProvider({ children }) {
  const history = useHistory()
  const [canGoBack, setCanGoBack] = React.useState(false)

  React.useEffect(() => {
    let keys = [history.location.key]
    let currentIndex = 0

    return history.listen((location, action) => {
      if (action === 'PUSH') {
        keys = [...keys.slice(0, currentIndex + 1), location.key]
        currentIndex += 1
      } else if (action === 'REPLACE') {
        keys[currentIndex] = location.key
      } else if (action === 'POP') {
        const index = keys.indexOf(location.key)
        if (index >= 0) {
          currentIndex = index
        } else {
          keys = [location.key]
          currentIndex = 0
        }
      }

      setCanGoBack(currentIndex > 0)
    })
  }, [history])

  return <BackNavigationContext.Provider value={canGoBack}>{children}</BackNavigationContext.Provider>
}

export function useCanGoBack() {
  return React.useContext(BackNavigationContext)
}
